// ============================================================
// SVG geometry from screen points: one closed path - the display's figures
// draw every projected outline (a head face, a lying capsule, a blob) with it -
// and a polyline's or polygon's `points`, so they share one rounding and one
// format.
//
// Pure. Zero React dependency.
// ============================================================

/** `M x y L x y ... Z` through the points, to a tenth of a pixel. */
export const closedPath = (pts: readonly { x: number; y: number }[]): string =>
  `${pts.map((p, i) => `${i ? 'L' : 'M'}${p.x.toFixed(1)} ${p.y.toFixed(1)}`).join(' ')} Z`;

/** A polyline's or polygon's `points`: `x,y x,y ...`, to a tenth of a pixel. */
export const pointsAttr = (pts: readonly { x: number; y: number }[]): string =>
  pts.map((p) => `${p.x.toFixed(1)},${p.y.toFixed(1)}`).join(' ');
